document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".config-box-form-page");
  if (container) {
    const links = container.querySelectorAll(".product-card__figure a");
    links.forEach(function (link) {
      link.removeAttribute("href");
    });
  }
});

/**
 * OPTIMIZACIÓN: Reducir tamaño de imágenes en bloques ai-media-text
 * Las imágenes se sirven a 1000px pero se muestran a máx 600px
 */
(function() {
  function optimizeAiMediaImages() {
    const slides = document.querySelectorAll('[class*="ai-media-text-slide-"] img, [class*="ai-media-text"] img');
    slides.forEach(function(img) {
      if (!img.src || img.src.includes('width=')) return;
      var baseSrc = img.src.split('?')[0];
      var params = new URLSearchParams(img.src.split('?')[1] || '');
      if (!baseSrc.includes('cdn/shop') && !baseSrc.includes('cdn/files')) return;
      params.set('width', '600');
      img.src = baseSrc + '?' + params.toString();
      if (!img.srcset) {
        img.srcset = [375, 600, 900].map(function(w) {
          var p = new URLSearchParams(params.toString());
          p.set('width', w);
          return baseSrc + '?' + p.toString() + ' ' + w + 'w';
        }).join(', ');
        img.sizes = '(max-width: 749px) calc(100vw - 40px), (max-width: 1024px) 48vw, 50vw';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeAiMediaImages);
  } else {
    optimizeAiMediaImages();
  }
})();

